<template>
  <canvas ref="ColoreSpessore" 
          :width="Width"
          :height="Height">
  </canvas>
</template>

<script>
export default 
{
  props: ["Colore", "Spessore", "Width", "Height", "Istogramma"],

  data() 
  {
    return  {

            }
  },

  methods: 
  {
    Paint()
    {
      if(this.Istogramma)
      {
        const ctx    = this.$refs.ColoreSpessore.getContext("2d");

        ctx.beginPath();
        // ctx.lineWidth   = this.Spessore
        ctx.fillStyle   = this.Colore
        ctx.fillRect(0,
                      10,
                      this.$refs.ColoreSpessore.width,
                      this.$refs.ColoreSpessore.height)  
      }
      else
      {
        const ctx    = this.$refs.ColoreSpessore.getContext("2d");

        ctx.beginPath();
        ctx.lineWidth   = this.Spessore
        ctx.strokeStyle = this.Colore
        ctx.moveTo(0, this.$refs.ColoreSpessore.height / 2);
        ctx.lineTo(this.$refs.ColoreSpessore.width, this.$refs.ColoreSpessore.height / 2);

        // Draw the Path
        ctx.stroke();
      }
    }
  },

  computed:
  {
    CurrentColore :
    {
      get()
      {
        return this.Colore
      }
    },
    CurrentSpessore :
    {
      get()
      {
        return this.Spessore
      }
    },
  },

  watch:
  {
    CurrentColore:
    {
      handler()
      {
        this.Paint()
      }
    },
    CurrentSpessore:
    {
      handler()
      {
        this.Paint()
      }
    },
  },

  mounted() 
  {
    this.Paint()
  }

}
</script>
